import { Injectable } from '@angular/core';
import * as moment from 'moment';

export type ShortMonthDayYearTime = string; // e.g. 'Jan 1, 2020 12:00:00 AM'
export type HourMinuteSecond = string; // e.g. '12:00:00 AM'
export type Milliseconds = number; // e.g. 1580515200000
export type Seconds = number; // e.g. 1580515200

@Injectable({
  providedIn: null
})
export abstract class DateTimeService {
  abstract setDateTimeFormats(locale: string, formats: moment.LocaleSpecification);
  abstract ymdToLongDate(val: moment.MomentInput): ShortMonthDayYearTime;

  abstract getNowMilliseconds(): Milliseconds;
  abstract getNowSeconds(): Seconds;
  abstract getNowTime(): HourMinuteSecond;

  abstract getTimeFromTimestamp(ts: Seconds): HourMinuteSecond;
  abstract getSeconds(hours: number, minutes: number, seconds: number): Seconds;
  abstract getMilliseconds(hours: number, minutes: number, seconds: number): Milliseconds;

  abstract olderThan24Hours(timestamp: string): boolean;
}
